/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, Text } from '@chakra-ui/react';
import { SelectOption } from '@diamond/shared/types';
import {
  ChakraStylesConfig as StylesConfig,
  components,
  OptionProps,
  Select as ReactSelect,
} from 'chakra-react-select';

const Option = (props: OptionProps<SelectOption, false>) => (
  <components.Option {...props}>
    <Flex justify="space-between" align="center" width="100%">
      {props.label}
      {props.isSelected && <Text>✓</Text>}
    </Flex>
  </components.Option>
);

const reactSelectStyles: StylesConfig<SelectOption, false> = {
  container: (base) => ({ ...base, minWidth: 160 }),
  menu: (base) => ({ ...base, zIndex: 98 }),
  indicatorSeparator: () => ({ display: 'none' }),
  valueContainer: (base) => ({ ...base, flexWrap: 'nowrap' }),
  control: (base, state) => ({
    ...base,
    minHeight: 10,
    borderRadius: 'var(--chakra-radii-md)',
    ...(state.isDisabled && {
      backgroundColor: 'var(--chakra-colors-gray-200)',
      borderColor: 'var(--chakra-colors-gray-300)',
      opacity: 1,
      cursor: 'not-allowed',
    }),
  }),
  singleValue: (base, state) => ({
    ...base,
    ...(state.isDisabled && {
      color: 'var(--chakra-colors-gray-600)',
    }),
  }),
  placeholder: (base, state) => ({
    ...base,
    ...(state.isDisabled && {
      color: 'var(--chakra-colors-gray-500)',
    }),
  }),
  input: (base, state) => ({
    ...base,
    ...(state.isDisabled && {
      color: 'var(--chakra-colors-gray-600)',
    }),
  }),
};

interface SelectProps {
  id: string;
  placeholder: string;
  options: SelectOption[];
  value: SelectOption | null;
  onChange: (value: SelectOption | null) => void;
}

export const Select = (props: SelectProps) => (
  <ReactSelect
    chakraStyles={reactSelectStyles}
    components={{ Option }}
    {...props}
  />
);
